import React from "react"
import * as styles from "./framePromoCallout.module.scss"

// Returns true when a promo should be shown: it must exist, not be hidden,
// and today must fall inside its optional start/end window.
export const isPromoActive = promo => {
  if (!promo) return false
  if (promo.visible === false) return false
  if (!promo.heading && !promo.text) return false

  const now = new Date()

  if (promo.startDate && new Date(promo.startDate) > now) return false
  if (promo.endDate && new Date(promo.endDate) < now) return false

  return true
}

const FramePromoCallout = ({ promo, className }) => {
  if (!isPromoActive(promo)) return null

  const { heading, text } = promo

  return (
    <aside
      className={className ? `${styles.callout} ${className}` : styles.callout}
      aria-label="Promotion"
    >
      {heading ? <p className={styles.heading}>{heading}</p> : null}
      {text ? <p className={styles.text}>{text}</p> : null}
    </aside>
  )
}

export default FramePromoCallout
